import { fetchOk } from '@atlassian/mpac-fetch-wrapper';
export const getBulkCloudMigrationOptIn = (mpacBaseUrl, appKeys) => {
  return fetchOk("".concat(mpacBaseUrl, "/gateway/api/marketplace/catalog/products/cloud-migration-trial-optin/bulk-fetch"), {
    method: 'POST',
    body: JSON.stringify(appKeys),
    headers: {
      'Content-Type': 'application/json'
    }
  }).then(response => response.json());
};
export const updateCloudMigrationOptIn = (mpacBaseUrl, body) => fetchOk("".concat(mpacBaseUrl, "/gateway/api/marketplace/catalog/products/cloud-migration-trial-optin/"), {
  method: 'PUT',
  body: JSON.stringify(body),
  headers: {
    'Content-Type': 'application/json'
  }
}).then(response => response.json());